<template>
  <v-card flat>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
      >
        <h3 style="margin-bottom: 20px; color: #425460">{{ vesselName }} - Type: {{ vesselType ? vesselType.name : "" }}</h3>
        <v-row>
          <v-col
            class="text-field"
          >
            <v-text-field
              v-model.number="length"
              class="text-field"
              suffix="m"
              type="number"
              step="0.1"
              outlined
              dense
              :rules="lengthRules"
              label="Length"
              @keydown="keyDown"
            ></v-text-field>
          </v-col>
          <v-col
            class="text-field"
          >
            <v-text-field
              v-model="width"
              suffix="m"
              type="number"
              step="0.1"
              outlined
              dense
              :rules="widthRules"
              label="Width"
              @keydown="keyDown"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="text-field"
          >
            <v-text-field
              v-model="draught"
              type="number"
              suffix="m"
              step="0.1"
              outlined
              dense
              :rules="draughtRules"
              label="Draught"
              @keydown="keyDown"
            ></v-text-field>
          </v-col>
          <v-col
            class="text-field"
          >
            <v-text-field
              v-model="tonnage"
              type="number"
              suffix="ton"
              step="0.1"
              outlined
              dense
              :rules="tonnageRules"
              label="Tonnage"
              @keydown="keyDown"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="text-field"
          >
            <v-text-field
              v-model="height"
              suffix="m"
              type="number"
              step="0.1"
              outlined
              dense
              :rules="heightRules"
              label="Height"
              @keydown="keyDown"
            ></v-text-field>
          </v-col>
          <v-col
            class="text-field"
          >
            <v-text-field
              v-model="speed"
              type="number"
              suffix="km/h"
              step="0.1"
              outlined
              dense
              :rules="speedRules"
              label="Cruising speed"
              @keydown="keyDown"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<style scoped>
.text-field {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
<script>
  import { mapState } from "vuex";
  import store from "../store";
  export default {
    name: 'Vessel',

    data: () => ({
      valid: true,
      lengthRules: [
        v => {
          if (!store.state.input.vesselType) return true;
          else if (v >= store.state.input.vesselType.length) return true;
          else return "Value too low for vessel spec"
        }
      ],
      widthRules: [
        v => {
          if (!store.state.input.vesselType) return true;
          else if (v >= store.state.input.vesselType.width) return true;
          else return "Value too low for vessel spec"
        }
      ],
      draughtRules: [
        v => {
          if (!store.state.input.vesselType) return true;
          else if (v <= store.state.input.vesselType.draught) return true;
          else return "Value too high for vessel spec"
        }
      ],
      tonnageRules: [
        v => {
          if (!store.state.input.vesselType) return true;
          else if (v <= store.state.input.vesselType.tonnage) return true;
          else return "Value too high for vessel spec"
        }
      ],
      heightRules: [
        v => {
          if (v == undefined) return true;
          else if (v >= 0) return true;
          else return "Must be positive"
        }
      ],
      speedRules: [
        v => {
          if (v == undefined) return true;
          else if (v >= 0) return true;
          else return "Must be positive"
        } 
      ]
    }),
    computed: {
      ...mapState({
        vessel: state => state.input.vessel,
        vesselType: state => state.input.vesselType,
        vesselName: state => {
          if (state.input.vessel) {
            return state.input.vessel.name;
          }
          return "";
        }
      }),
      length: {
        get() {
          if (this.$store.state.input.length) {
            return this.$store.state.input.length;
          }
          if (this.$store.state.input.vesselType) {
            this.$store.commit("setLength", this.$store.state.input.vesselType.length)
            return this.$store.state.input.vesselType.length
          }
          return 0;
        },
        set(value) {
          this.$store.commit("setLength", value);
        } 
      },
      width: {
        get() {
          if (this.$store.state.input.width) {
            return this.$store.state.input.width;
          }
          if (this.$store.state.input.vesselType) {
            this.$store.commit("setWidth", this.$store.state.input.vesselType.width)
            return this.$store.state.input.vesselType.width
          }
          return 0;
        },
        set(value) {
          this.$store.commit("setWidth", value);
        } 
      },
      draught: {
        get() {
          if (this.$store.state.input.draught) {
            return this.$store.state.input.draught;
          }
          if (this.$store.state.input.vesselType) {
            this.$store.commit("setDraught", this.$store.state.input.vesselType.draught)
            return this.$store.state.input.vesselType.draught
          }
          return 0;
        },
        set(value) {
          this.$store.commit("setDraught", value);
        } 
      },
      tonnage: {
        get() {
          if (this.$store.state.input.tonnage) {
            return this.$store.state.input.tonnage;
          }
          if (this.$store.state.input.vesselType) {
            this.$store.commit("setTonnage", this.$store.state.input.vesselType.tonnage)
            return this.$store.state.input.vesselType.tonnage
          }
          return 0;
        },
        set(value) {
          this.$store.commit("setTonnage", value);
        } 
      },
      height: {
        get() {
          return this.$store.state.input.height;
        },
        set(value) {
          this.$store.commit("setHeight", value);
        }
      },
      speed: {
        get() {
          return this.$store.state.input.speed;
        },
        set (value) {
          this.$store.commit("setSpeed", value);
        }
      }
    },
    methods: {
      save: function() {
        localStorage.setItem("ces-state", JSON.stringify(this.$store.state.input));
      },
      validate: function() {
        return this.$refs.form.validate();
      },
      resetValidation: function() {
        this.$refs.form.resetValidation();
      },
      keyDown: function(e) {
        console.log(e);
        if ((/^[a-z,A-Z]$/i.test(event.key))) {
          e.preventDefault(true);
        }
      }
    }
  }
</script>
